import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { 
  initializeFirestore, // getFirestore čia nebereikia
  persistentLocalCache, 
  persistentMultipleTabManager 
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD6kN-g_PdI7oHd--ErDE03f3bnDYEItb8",
  authDomain: "buildforce-al-new-b0c54.firebaseapp.com",
  projectId: "buildforce-al-new-b0c54",
  storageBucket: "buildforce-al-new-b0c54.firebasestorage.app",
  messagingSenderId: "68751544674",
  appId: "1:68751544674:web:27f20fb74ffe286f0ddc3b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Auth
export const auth = getAuth(app);

// SUTVARKYTAS OFFLINE REŽIMAS (v10+)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager() 
  })
});

// Export Storage
export const storage = getStorage(app);